import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LocusRobotics_ds_jobs_header_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { fullTextSearch?: string, orderId?: string, projectIds?: number[], warehouseId?: number, $top?: number, $skip?: number }): Promise<{ result?: { jobId?: string, status?: string, project?: string, warehouse?: string, customer?: string, orderId?: string, jobCount?: number, totalUnits?: number, botType?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, orderId?: string, projectIds?: number[], warehouseId?: number, $keys: string[] }): Promise<{ result?: { jobId?: string, status?: string, project?: string, warehouse?: string, customer?: string, orderId?: string, jobCount?: number, totalUnits?: number, botType?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}
